import { defineComponent as _defineComponent } from 'vue'
import { useApiStore, type LaudMarker } from "@/stores/api";
import { ref, Ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const apiStore = useApiStore();
const markers: Ref<Array<{ position: { lat: number; lng: number } }>> = ref([]);
const openedMarkerID: Ref<null | number> = ref(null);

apiStore.getMarkers().then(
    (m) =>
        (markers.value = m.map((lm) => {
            return { meta: lm, position: { lat: lm.lat, lng: lm.lng } };
        })),
);

const center = ref({ lat: 50.9382842, lng: 5.3371564 });
const offices = [
    {
        position: {
            lat: 50.938154,
            lng: 5.337717,
        },
    },
];

const options = {
    streetViewControl: false,
    draggingCursor: false,
    zoomControl: true,
    mapTypeControl: false,
    fullscreenControl: false,
    keyboardShortcuts: false,
    styles: [
        {
            featureType: "poi",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "all",
            elementType: "all",
            stylers: [{ saturation: -150 }],
        },
    ],
};

const openMarker = (id: number | null, m?: { position: { lat: number; lng: number } } | null) => {
    openedMarkerID.value = id;
    if (m) {
        center.value = m.position;
    }
};

const __returned__ = { apiStore, markers, openedMarkerID, center, offices, options, openMarker }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})